import RegexUtils from 'utils/RegexUtils';
import { bool, object, string } from 'yup';

const { phoneRegex } = RegexUtils;

const CheckAvailabilitySchema = object().shape({
    firstNameId: string().required('First Name is required').max(70),
    lastNameId: string().required('Last Name is required').max(70),
    messageId: string().required('Message is required').max(500),
    contactMethod: string(),
    fromEmailId: string().when('contactMethod', {
        is: (contactMethod:string) => contactMethod === 'email',
        then: string().email('email must be a valid email').required('Email is required'),
    }),
    phoneId: string().when('contactMethod', {
        is: (contactMethod:string) => contactMethod !== 'email',
        then: string().required('Phone is required').matches(phoneRegex, 'cell phone is not valid, please use this format 999-999-9999'),
    }),
    agreeid: bool().required().oneOf([true], "The terms and conditions must be accepted."),
});

export default CheckAvailabilitySchema;
